import http from './http'

export function getVendors() {
  return http.get('/api/admin/vendors')
}

export function createVendor(data) {
  return http.post('/api/admin/vendors', data)
}

export function updateVendor(id, data) {
  return http.put(`/api/admin/vendors/${id}`, data)
}

export function deleteVendor(id) {
  return http.delete(`/api/admin/vendors/${id}`)
}

export function getSegments() {
  return http.get('/api/admin/segments')
}

export function createSegment(data) {
  return http.post('/api/admin/segments', data)
}

export function updateSegment(id, data) {
  return http.put(`/api/admin/segments/${id}`, data)
}

export function deleteSegment(id) {
  return http.delete(`/api/admin/segments/${id}`)
}

export function changeAdminPassword(data) {
  return http.post('/api/admin/change-password', data)
}

export function getAdminSNs(params) {
  return http.get('/api/admin/sn-codes', { params })
}

export function getCircles() {
  return http.get('/api/admin/circles')
}

export function createCircle(data) {
  return http.post('/api/admin/circles', data)
}

export function updateCircle(id, data) {
  return http.put(`/api/admin/circles/${id}`, data)
}

export function deleteCircle(id) {
  return http.delete(`/api/admin/circles/${id}`)
}

export function getCompanies() {
  return http.get('/api/admin/companies')
}

export function createCompany(data) {
  return http.post('/api/admin/companies', data)
}

export function updateCompany(id, data) {
  return http.put(`/api/admin/companies/${id}`, data)
}

export function deleteCompany(id) {
  return http.delete(`/api/admin/companies/${id}`)
}
